import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { ImpersonationService } from './impersonation.service';


export const impHeadersInterceptor: HttpInterceptorFn = (
  req: HttpRequest<any>, next: HttpHandlerFn
): Observable<HttpEvent<any>> => {
  const imp = inject(ImpersonationService);

  return next(req).pipe(
    tap({
      next: (event: any) => {
        if (event?.type === 4 && event.headers) {

          const rec: Record<string, string> = {};
          for (const k of event.headers.keys()) rec[k] = event.headers.get(k) ?? '';
          imp.updateFromHeaders(rec);
        }
      },
      error: () => {

      }
    })
  );
};
